<template>
  <div class="step3">
    <div class="content">
      <div>尊敬的心动网络用户，我们在此善意的提醒您，在您注销心动账号后，</div>
      <div style="font-weight: bolder">
        您将无法再以此账号登录和使用任何心动网络的产品与服务（包括但不限于心动网络发行/运营的游戏产品），该账号在使用期间产生的全部收益将被清除；您该账号下的个人信息将会被删除或匿名化处理（法律法规另有规定或监管部门另有要求的除外），您将无法再检索、访问、获取、继续使用和找回，也无权要求我们找回；同时，账号注销一旦完成，将无法恢复。
      </div>
      <br />
      <div>若您经过慎重考虑后仍执意决定注销心动账号，</div>
      <div></div>
      <div style="font-weight: bolder">
        请您务必先行仔细阅读和充分理解
        <a @click="toggleDialog" style="text-decoration: underline;">《账号注销协议》</a>，
      </div>
      <div>
        在同意全部内容后，按照我们的页面提示点击进行下一步操作，您勾选本注销协议并点击下一步注销操作的行为即视为您已经同意签署和遵守本协议全部内容。
      </div>
    </div>
    <!-- <div class="divider"></div> -->
    <div class="next-step w-full">
      <div class="agree-radio">
        <van-checkbox checked-color="#FF6600" v-model="checked"></van-checkbox>
        <div>我已阅读并同意 <a style="text-decoration: underline;" @click="toggleDialog">《账号注销协议》</a></div>
      </div>
      <Button :disabled="!checked" @click="goToNextStep" class="default-xd-button" text="下一步" />
      <Diglog
        :show="isShowDialog"
        :inLineStyle="cancellationAgreementContentStyle"
        class="dialog"
      >
        <template v-slot:content>
          <div class="cancellation-agreement-content" style="height: calc(100% - 150px);">
            <div :style="cancellationAgreementTitle">心动账号注销协议</div>
            <CancellationAgreement />
          </div>
        </template>
        <template v-slot:footer class="footer">
          <div
            style="border-top: 1px solid #8a8a8a1f"
            class="i-know-container w-full flex justify-center mb-5"
          >
            <Button
              @click="toggleDialog"
              class="i-know default-xd-button w-11/12 mt-5"
              text="我知道了"
            />
          </div>
        </template>
      </Diglog>
    </div>
  </div>
</template>

<script>
// import Input from '../../components/input'
import Button from '../../components/button'
import Diglog from '../../components/dialog'
import CancellationAgreement from './modal/cancellation-agreement'
import { Toast } from 'vant'

export default {
  props: {
    nextStep: {
      type: Function,
      default: () => {}
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      placeHolder: '请输入你的心动 IDxxx',
      value: '',
      checked: false,
      isShowDialog: false,
      cancellationAgreementContentStyle: {
        width: '89%',
        border: '1px solid #E6E6E6',
        'border-radius': '5px',
        height: '90%'
      },
      cancellationAgreementTitle: {
        height: '58px',
        'border-bottom': '1px solid #8a8a8a1f',
        'text-align': 'center',
        'font-family': 'PingFang SC',
        'font-style': 'normal',
        'font-weight': '500',
        'font-size': '16px',
        'line-height': '58px',
        'flex-shrink': '0',
        /* identical to box height, or 162% */
        'letter-spacing': '4.93506e-09px',
        color: '#333333'
      }
    }
  },
  components: {
    Button,
    Diglog,
    CancellationAgreement
  },
  mounted () {
    if (!window.cancelDetails) {
      this.$router.push({ name: 'Home', hash: '#step1', params: { index: 2 } })
    }
  },
  methods: {
    toggleDialog () {
      this.isShowDialog = !this.isShowDialog
    },
    goToNextStep () {
      if (!this.checked) {
        Toast('您必须同意帐号注销协议!')
        window.cancellationAgreement = null
        return
      }
      // console.log('goToNextStep')
      this.$emit('nextStep')
      window.cancellationAgreement = true
    },
    onInputChange (e) {
      console.log(e)
    }
  }
}
</script>

<style lang="less" scoped>
.divider {
  position: fixed;
  height: 1px;
  width: 900px;
  margin-left: -99px;
  background-color: #8a8a8a1f;
  bottom: 145px;
}
.step3 {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .cancellation-agreement-content {
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .content {
    margin-top: 16px;
    text-align: left;
    font-family: PingFang SC;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
    /* or 171% */
    text-align: justify;
    letter-spacing: 4.93507e-9px;
    /* 正文 */
    color: #5c5c5c;
    a {
      text-decoration: underline;
      color: #ff6600;
    }
    div {
      font-family: PingFang SC;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 24px;
      /* or 171% */

      letter-spacing: 4.93507e-9px;

      /* 正文 */

      color: #5c5c5c;
      display: contents;
    }
  }
  .next-step {
    margin-top: 51px;
    height: 124px;
    display: flex;
    flex-direction: column;
    align-items: center;
    a {
      text-decoration: underline;
      color: #ff6600;
    }
    .agree-radio {
      text-align: left;
      width: 100%;
      .van-checkbox {
        margin-right: 8px;
      }
      display: flex;
      flex-direction: row;
      font-family: PingFang SC;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 24px;
      /* or 171% */
      /* 黑色 */
      color: #333333;
      /* Inside Auto Layout */
      flex-grow: 0;
      margin: 8px 0px;
    }
    button {
      margin-top: 20px;
      width: 100%;
    }
  }
}
</style>
